<template>
  <v-app>
    <appbar/>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<style lang="scss">
@font-face {
  font-family: "Italian Plate";
  src: local("Italian Plate"),
   url(fonts/ItalianPlateNo2Expanded-Bold.otf) format("truetype");
}
@font-face {
  font-family: "Italian Plate origin";
  src: local("Italian Plate"),
   url(fonts/ItalianPlateNo2Expanded-Regular.otf) format("truetype");
}

</style>

<script>
import Appbar from '@/components/appbar.vue'

export default {
  name: "homepage",
  components: {
    Appbar,
  },
}
</script>
